// @flow
/**
 * User: Mike Chung
 * Date: 20/1/2018
 * Time: 8:53 PM
 */
import React from 'react';
import EBadge from "../../model/ebadge/EBadge";
import UnlockEBadgeButton from "../../containers/ebadge/UnlockEBadgeButton";
import TableRow from "../util/tables/TableRow";
import TableCell from "../util/tables/TableCell";
import LockEBadgeButton from "../../containers/ebadge/LockEBadgeButton";
import {connect} from "react-redux";
import {Country} from "../../model/Country";
import type {StoreState} from "../../reducers/combinedReducers";
import {computeUserConfigs, findCountryNameBySymbol} from "../../helpers/utils";
import config from '../../config/config';
import EbadgeEmailButton from "../ebadge/EbadgeEmailButton";
import EBadgeRegistrationCode from "../ebadge/EBadgeRegistrationCode";
import type {RoleConfig} from "../../types/utilityTypes";
import ValidateEBadgeButton from "../../containers/ebadge/ValidateEBadgeButton";
import InvalidateEBadgeButton from "../../containers/ebadge/InvalidateEBadgeButton";
import FairConfig from "../../model/fair/FairConfig";
import { getLabelByValue } from "../constants/SearchFormConstants"

type OwnProps = {
    eBadge: EBadge,
    fairName: string
};
type EBadgeTableRowProps = OwnProps & {
    countries: Array<Country>,
    enableLinkButton: boolean,
    enablePhotoEBadge: boolean,
    enableLinkToPhotoMgmt: boolean,
    enableVerifyButtons: boolean
};




function EBadgeTableRow(props: EBadgeTableRowProps) {
    const e = props.eBadge;

    return (
        <TableRow>
            <TableCell>{props.fairName}</TableCell>
            <TableCell>{e.companyName}</TableCell>
            <TableCell style={{textAlign: 'center'}}>{e.salutation}</TableCell>
            <TableCell>{e.firstName}</TableCell>
            <TableCell>{e.lastName}</TableCell>
            <TableCell>{findCountryNameBySymbol(props.countries, e.countryCode)}</TableCell>
            <TableCell>{config.enableTheLinkInEmailField ? <EbadgeEmailButton email={e.email}/> : e.email}</TableCell>
            <TableCell>{(config.isAbleToHighlightYearForRegCode) ?
                <EBadgeRegistrationCode linkToPhotoMgmt={props.enableLinkToPhotoMgmt} content={e.registrationCode} isMatchBlockList={e.isMatchBlockList}/> : e.registrationCode}</TableCell>
            <TableCell style={{textAlign: 'center'}}>{e.boothNumber}</TableCell>
            <TableCell className={"text-capitalize"}>{e.status}</TableCell>
            <TableCell style={{textAlign: 'center'}}>{e.isMarkedDelete}</TableCell>
            <TableCell style={{textAlign: 'center'}}>{e.unlockCount}</TableCell>                       
            <TableCell style={{textAlign: 'center'}}>{e.isVerifiedData}</TableCell>
            <TableCell style={{textAlign: 'center'}}>{e.readableRefId}</TableCell>
            <TableCell style={{textAlign: 'center'}}>{getLabelByValue("sourceTypes",e.sourceType)}</TableCell>
            <TableCell style={{textAlign: 'center'}}>{getLabelByValue("visitorType",e.visitorType)}</TableCell>
            <TableCell style={{textAlign: 'center'}}>{e.lastModifyDate}</TableCell>
            <TableCell style={{textAlign: 'center'}}>
                {
                    e.isVerifiedData !== 'Y' && props.enableVerifyButtons &&
                    <ValidateEBadgeButton unlockCount={e.unlockCount} color={"success"} block={false} registrationCode={e.registrationCode}
                                          label={"Validate"} loadingComponent={"Validating..."} className={"light-green"}/>
                }
                {" "}
                {
                    e.isVerifiedData === 'Y' && props.enableVerifyButtons &&
                    <InvalidateEBadgeButton unlockCount={e.unlockCount} color={"danger"} block={false} registrationCode={e.registrationCode}
                                            label={"Invalidate"} loadingComponent={"Invalidating..."} className={"light-red"}/>
                }
                {" "}
                {
                    e.status === 'redeemed' && e.isMarkedDelete !=='Y' &&
                    <UnlockEBadgeButton unlockCount={e.unlockCount} color={"danger"} block={false} registrationCode={e.registrationCode}
                                        disabled={e.status !== 'redeemed'} label={"Unlink"} loadingComponent={"Unlinking..."}/>
                }
                {" "}
                {
                    e.status === 'pending' && props.enableLinkButton && e.isMarkedDelete !=='Y' &&
                    <LockEBadgeButton unlockCount={e.unlockCount} color={"success"} block={false} registrationCode={e.registrationCode}
                                      disabled={e.status !== 'pending'} label={"Link"} loadingComponent={"Linking..."}/>
                }
            </TableCell>
        </TableRow>);
}

export default connect((state: StoreState, ownProps: OwnProps) => {
    const roleConfig: RoleConfig = computeUserConfigs(state.loginUser.roleIds);
    const eBadge = ownProps.eBadge;
    const fairConfig: ?FairConfig = state.fairConfigs.configByProjectCode[eBadge.projectCode] && state.fairConfigs.configByProjectCode[eBadge.projectCode][eBadge.year];

    return {
        countries: [].concat(state.countries),
        enableLinkButton: roleConfig.allowToLinkEBadge,
        enableVerifyButtons: roleConfig.allowToVerify && fairConfig && (fairConfig.ebadgeMode === 'Photo' || fairConfig.ebadgeMode === 'TradeNPub'),
        enableLinkToPhotoMgmt: roleConfig.allowPhotoEBadgeManagement,
        enablePhotoEBadge: fairConfig && fairConfig.ebadgeMode==='Photo'
    }
})(EBadgeTableRow);


// WEBPACK FOOTER //
// ./src/components/ebadge/EBadgeTableRow.js